module.exports = __webpack_public_path__ + "ebf3fe7be65261ec9cb12beac4a63fbe.svg";